import { render, staticRenderFns } from "./ModalCadastroDireito.vue?vue&type=template&id=598e3908"
import script from "./ModalCadastroDireito.vue?vue&type=script&lang=js"
export * from "./ModalCadastroDireito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports